import React, { useState } from "react";
import moment from "moment";
import {
  List,
  Datagrid,
  TextField,
  DateInput,
  BulkActionsToolbar,
  FilterForm,
  useNotify,
  useRefresh,
  useUnselectAll,
  useListContext,
} from "react-admin";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField as MuiTextField,
} from "@mui/material";

/* ================= FILTER ================= */

const birthdayFilters = [
  <DateInput
    key="dobDate"
    source="dobDate"
    label="DOB Date"
    alwaysOn
  />,
];

/* ================= ASIDE ================= */

const BirthdayAside = () => (
  <Box p={2} width={300}>
    <Typography variant="h6" gutterBottom>
      🎂 Select Date
    </Typography>
    <FilterForm filters={birthdayFilters} />
  </Box>
);

/* ================= EMPTY STATE ================= */

const EmptyBirthdays = () => (
  <Box textAlign="center" mt={4}>
    <Typography variant="h6">No Birthdays yet</Typography>
    <Typography variant="body2" color="textSecondary">
      Please select another date from the calendar
    </Typography>
  </Box>
);

/* ================= BULK SEND BUTTON ================= */

const SendBirthdayGreetingsButton = () => {
  const { selectedIds = [] } = useListContext(); // get selected rows from context
  const notify = useNotify();
  const refresh = useRefresh();
  const unselectAll = useUnselectAll();

  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [bodyvalue, setBodyvalue] = useState("");

  const handleSend = async () => {
    try {
      await fetch("https://tovpadmin.com/api/admin/sendBirthdayGreetings", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("token"),
        },
        body: JSON.stringify({
          title,
          bodyvalue,
          users: selectedIds,
        }),
      });

      notify("Birthday greetings sent 🎉", { type: "success" });
      setOpen(false);
      setTitle("");
      setBodyvalue("");
      unselectAll("users");
      refresh();
    } catch (error) {
      notify("Failed to send greetings", { type: "error" });
    }
  };

  return (
    <>
      <Button
        variant="contained"
        disabled={selectedIds.length === 0} // disabled if no rows selected
        onClick={() => setOpen(true)}
        sx={{ mt: 1 }} // margin top to avoid cropping
      >
        Send Greetings
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth>
        <DialogTitle>Send Birthday Greetings</DialogTitle>
        <DialogContent>
          <MuiTextField
            fullWidth
            label="Title"
            margin="dense"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <MuiTextField
            fullWidth
            label="Message"
            margin="dense"
            multiline
            rows={4}
            helperText="Use $userName to personalize"
            value={bodyvalue}
            onChange={(e) => setBodyvalue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={!title || !bodyvalue}
            onClick={handleSend}
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

/* ================= BULK ACTION TOOLBAR ================= */

const CustomBulkActions = (props) => (
  <BulkActionsToolbar {...props}>
    <Box sx={{ py: 1, display: "flex", alignItems: "center" }}>
      <SendBirthdayGreetingsButton />
    </Box>
  </BulkActionsToolbar>
);

/* ================= MAIN LIST ================= */

const UsersBirthdayList = (props) => (
  <Box sx={{ mt: 4 /* or any value you want, e.g., 5, 6, etc. */ }}>
    <List
      {...props}
      aside={<BirthdayAside />}
      empty={<EmptyBirthdays />}
      emptyWhileLoading={false}
      filterDefaultValues={{ dobDate: moment().format("YYYY-MM-DD") }}
    >
      <Datagrid rowClick="show" bulkActionButtons={<CustomBulkActions />}>
        <TextField source="continent" />
        <TextField source="country" />
        <TextField source="legalName" />
        <TextField source="email" />
        <TextField source="phone" />
        <TextField source="dob" />
      </Datagrid>
    </List>
  </Box>
);

export default UsersBirthdayList;
export const BirthdaysShow = UsersBirthdayList;
